<template>
  <DialogComponent
    @submit="onSubmit"
    :title="this.title"
  >
    <form @submit="onSubmit">
      <div class="image-preview">
        <img height="150px" v-if="thumb" :src="thumb">
        <i v-if="!thumb" class="mdi mdi-account-circle"></i>
      </div>

      <b-form-group
        id="photoUrl"
        label="Photo URL:"
        label-for="photoUrl"
      >
        <input
          id="photoUrl"
          type="text"
          v-model="photoUrl"
          placeholder="Enter image URL"
          v-validate="'required'"
          data-vv-as="Image URL"
          name="photoUrl"
          class="form-control"
          :class="{'is-invalid': errors.has('photoUrl')}"
          autofocus
        />
        <span
          v-show="errors.has('photoUrl')"
          class="error-message"
        >
          {{ errors.first('photoUrl') }}
        </span>
      </b-form-group>
    </form>
  </DialogComponent>
</template>

<script>
import DialogComponent from '@/components/Dialog';

import USER_PHOTO from '@/graphql/Users/UserPhoto.gql';
import UPDATE_USER_PHOTO from '@/graphql/Users/UpdateUserPhoto.gql';
import ModalMixin from '@/mixins/ModalMixin';

export default {
  name: 'user-photo',
  mixins: [ModalMixin],
  components: {
    DialogComponent,
  },
  props: {
    id: String,
  },

  data() {
    return {
      photoUrl: null,
      thumb: null,
    };
  },
  computed: {
    title() {
      return `User Photo`;
    },
  },
  methods: {
    async onSubmit() {
      try {
        const valid = await this.$validator.validateAll();
        if (!valid) {
          return;
        }
      } catch (e) {
        return;
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_PHOTO,
          variables: {
            id: parseInt(this.id),
            photoUrl: this.photoUrl,
          },
          refetchQueries: ({ data }) => {
            const response = data.updateUserPhoto;
            return response && response.success ? ['users'] : [];
          },
        })
        .then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: `User photo was updated`,
          });
          this.close();
        })
        .catch(e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        });
    },
  },
  apollo: {
    user: {
      query: USER_PHOTO,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          id: +this.id,
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.photoUrl = data.user.photo.fullSize;
          this.thumb = data.user.photo.thumb150;
        }
      },
      skip() {
        return !this.id;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.image-preview {
  min-height: 184px;
  text-align: center;
  i {
    font-size: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/UserPhotoModal.vue